import React, { useState } from "react";
import { convertToEINString, getDropdownOptions } from "../../../Helpers";
import { BrokerConstants } from "../../constants/BrokerConstants";
import { GlobalConstants } from "../../constants/GlobalConstants";
import { FeatureFlags } from "../../constants/LocalServerConstants";
import BPLoanALReoTables from "./BPLoanALReoTables";
import BPLoanDetailSection from "./BPLoanDetailSection";

interface ILoanBorrowerContentProps {
  accordionProps: any;
  applicationMetadata: any;
  borrowerApplicationInfo: any;
  brokerColor: any;
  proxyUserId: any;
  isEditMode: boolean;
  isLoanInfo: any;
  invalidProps: any;
  borrower: any;
  borrowerPatchObj: any;
  setBorrowerPatchObj: any;
  handleALDeleteAsync: any;
  handleREODeleteAsync: any;
}

const BPLoanBorrowerContent = ({ ...props }: ILoanBorrowerContentProps) => {
  const [borrowerAdditiionalInfo, setBorrowerAdditionalInfo] = useState({} as any);

  return (
    <React.Fragment>
      <BPLoanDetailSection
        title={BrokerConstants.InteriorCardAccordions.BorrowerInformation.name}
        accordionId={BrokerConstants.InteriorCardAccordions.BorrowerInformation.id}
        accordionObject={props.borrowerPatchObj}
        setAccordionObject={props.setBorrowerPatchObj}
        subPatchObj={props.borrowerPatchObj}
        setSubPatchObj={props.setBorrowerPatchObj}
        isEditMode={props.isEditMode}
        {...props.accordionProps}
        invalidProps={props.invalidProps}
        validationGroupName="borrower"
        inputs={[
          {
            value: props.borrower.name,
            label: "Name:",
            field: "name",
            size: 4,
            required: true
          },
          {
            value: props.borrower.entitySubTypeId,
            label: "Type:",
            size: 4,
            field: "entitySubTypeId",
            dropdown: getDropdownOptions(props.applicationMetadata.entitySubTypes, ["id"], "name"),
          },
          {
            value: convertToEINString(props.borrower.employerIdentificationNumber),
            label: "EIN:",
            field: "employerIdentificationNumber",
            inputType: GlobalConstants.InputTypes.EIN,
            size: 4
          },
          {
            value: props.borrower,
            address: true,
            addressObj: {
              address: props.borrower.physicalStreet,
              city: props.borrower.physicalCityName,
              state: props.borrower.physicalStateName,
              zip: props.borrower.physicalZipCode,
            },
            defaultValueObj: {...props.borrower},
            placeDetailsObject: props.borrowerPatchObj,
            setPlaceDetailsObject: props.setBorrowerPatchObj,
            required: true,
            fieldsNameOverridesArray: [
              {
                addressComponent: "address",
                field: "physicalStreet"
              },
              {
                addressComponent: "city",
                field: "physicalCityName"
              },
              {
                addressComponent: "state",
                field: "physicalStateName"
              },
              {
                addressComponent: "county",
                field: "physicalCountyName"
              },
              {
                addressComponent: "zip",
                field: "physicalZipCode"
              },
            ],
            label: "Address",
            size: 8
          }
        ]}
      />
      <BPLoanDetailSection
        title={BrokerConstants.InteriorCardAccordions.BorrowerExperience.name}
        accordionId={BrokerConstants.InteriorCardAccordions.BorrowerExperience.id}
        mainPatchObj={props.borrowerPatchObj}
        setMainPatchObj={props.setBorrowerPatchObj}
        subPatchObjName="additionalInformation"
        subPatchObj={borrowerAdditiionalInfo}
        setSubPatchObj={setBorrowerAdditionalInfo}
        isEditMode={props.isEditMode}
        {...props.accordionProps}
        inputs={[
          {
            value: props.borrower.yearsInIndustry,
            label: "Years in Business:",
            size: 4,
            field: "yearsInIndustry",
            inputType: GlobalConstants.InputTypes.INT,
            unitType: "Years"
          },
          {
            value: props.borrower.borrowerProjectExperience,
            label: "Homes completed in the last 18 months:",
            field: "borrowerProjectExperience",
            size: 4
          },
          {
            value: props.borrower.monthlyRevenue,
            label: "Gross Revenue (Two Year Average):",
            size: 4,
            field: "monthlyRevenue",
            unitType: "$"
          },
          {
            value: props.borrower.monthlyIncome,
            label: "Net Income (Two Year Average)",
            size: 4,
            field: "monthlyIncome",
            unitType: "$"
          }
        ]}
      />
      <BPLoanALReoTables
        accordionProps={props.accordionProps}
        applicationMetadata={props.applicationMetadata}
        brokerColor={props.brokerColor}
        invalidProps={props.invalidProps}
        isEditMode={props.isEditMode}
        assetTitle={BrokerConstants.InteriorCardAccordions.BorrowerAssets.name}
        assetAccordionId={BrokerConstants.InteriorCardAccordions.BorrowerAssets.id}
        liabilitiesTitle={BrokerConstants.InteriorCardAccordions.BorrowerLiabilities.name}
        liabilitiesAccordionId={BrokerConstants.InteriorCardAccordions.BorrowerLiabilities.id}
        reoTitle={BrokerConstants.InteriorCardAccordions.BorrowerREO.name}
        reoAccordionId={BrokerConstants.InteriorCardAccordions.BorrowerREO.id}
        isOrganization={true}
        organizationContact={props.borrower}
        mainPatchObj={props.borrowerPatchObj}
        setMainPatchObj={props.setBorrowerPatchObj}
        handleALDeleteAsync={props.handleALDeleteAsync}
        handleREODeleteAsync={props.handleREODeleteAsync}
      />
      {FeatureFlags.IS_DEBUG && <React.Fragment>
        <button onClick={() => console.log(props.borrower)}>props.borrower</button>
        <button onClick={() => console.log(props.borrowerPatchObj)}>props.borrowerPatchObj</button>
      </React.Fragment>}
    </React.Fragment>
    );
  };
  
  export default BPLoanBorrowerContent;